import React from 'react';
import classnames from 'classnames';
import styles from './radio.scss';

type Props = {
  id: string,
  name: string,
  value: string,
  checked: boolean,
  onChange: (evt: React.ChangeEvent<HTMLInputElement>) => void
  disabled?: boolean,
  className?: string,
  'data-qa-ref'?: string,
}

const unselected = (
  <path
    d="M15.5 8a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z"
    fill="#fff"
    stroke="#959CA4" />
);
const selected = (
  <React.Fragment>

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 16A8 8 0 108 0a8 8 0 000 16z"
      fill="#0078A0" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 11a3 3 0 100-6 3 3 0 000 6z"
      fill="#fff" />
  </React.Fragment>
);


export default function Radio({
  id, name, checked, onChange, value, disabled, className, ...rest
}: Props) {

  return (
    <React.Fragment>
      <input
        className={styles.realRadio}
        type="radio"
        id={id}
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={onChange} />

      <label htmlFor={id} className={classnames(styles.svgLabel, className)} {...rest}>
        <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none">
          {checked ? selected : unselected }
        </svg>
      </label>
    </React.Fragment>
  );
}
